<template>
  <v-container class="pa-3 mt-16">
    <v-row>
      <v-col align="center">
        <v-img max-width="55%" src="../assets/erp-logo.png"> </v-img>
        <h5 style="font-weight: normal; color: #888" class="pt-2 pb-5">
          Please sign in to continue
        </h5>
      </v-col>

      <!-- <v-col class="py-8" cols="12">
        <h2 align="left">Welcome</h2>
        <h5 style="font-weight: normal; color: #888" align="left">
          Please sign in to continue
        </h5>
      </v-col> -->

      <v-col cols="12">
        <v-form>
          <v-text-field
            label="Username"
            v-model="form.username"
            prepend-icon="mdi-account-circle"
          />
          <v-text-field
            v-model="form.password"
            :type="showPassword ? 'text' : 'password'"
            label="Password"
            prepend-icon="mdi-lock"
            @click:append="showPassword = !showPassword"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          />
        </v-form>
      </v-col>
      <v-col>
        <v-btn
          color="primary"
          :loading="isLoading"
          :disabled="isLoading"
          @click="handleLogin()"
          depressed
          block
          elevation="2"
          >Login</v-btn
        >
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar" color="error" timeout="2500"
      >{{ snackbar_message }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>
<script>
export default {
  data: () => ({
    showPassword: false,
    snackbar_message: "",
    snackbar: false,
    form: {
      username: "",
      password: "",
      type: 3,
    },
    isLoading: false,
  }),
  created() {},
  methods: {
    handleLogin() {
      if (this.form.username === "") {
        this.snackbar_message = "Please enter your username";
        this.snackbar = true;
        return;
      }
      if (this.form.password === "") {
        this.snackbar_message = "Please enter your password";
        this.snackbar = true;
        return;
      }

      this.isLoading = true;
      this.$auth
        .login(this.form)
        .then(() => {
          this.$router.push("/");
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
          this.snackbar_message = "Access denied / Server error occured !!";
          this.snackbar = true;
        });
    },
  },
};
</script>
